import React from 'react';
import PropTypes from 'prop-types';

import { UnitAmenityIcon } from 'components/unit/UnitAmenityIcon';
import { Modal, ModalBody, ModalTitle } from 'components/core/Modal';
import { H3, Paragraph } from 'components/core/Typography';
import { unitAmenityOptions } from 'config/units';

import './UnitAmenityModal.scss';

export function UnitAmenityModal({ showing, onClose, unitAmenities }) {
	return (
		<Modal
			className="unit-amenity-modal"
			showing={showing}
			onClose={onClose}
		>
			<ModalTitle>
				<H3
					last
					size="medium"
				>
					Amenities Guide
				</H3>
			</ModalTitle>
			<ModalBody>
				<div className="unit-amenity-cards">
					{unitAmenities.map((option) => (
						<div
							className="unit-amenity-card"
							key={option.title}
						>
							<UnitAmenityIcon amenity={option.amenity} />
							<Paragraph className="amenity-title">
								{option.title}
							</Paragraph>
							<Paragraph className="amenity-details">
								{option.details}
							</Paragraph>
						</div>
					))}
				</div>
			</ModalBody>
		</Modal>
	);
}

UnitAmenityModal.propTypes = {
	showing: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	unitAmenities: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string,
			image: PropTypes.any,
			details: PropTypes.string,
		}),
	),
};

UnitAmenityModal.defaultProps = {
	unitAmenities: unitAmenityOptions,
};

export default UnitAmenityModal;
